import { getParentOfType, types } from 'mobx-state-tree';

import { RequestStateType } from '../../types/RequestState';
import ProductCollectionItem from './collection/ProductCollectionItem';
import ProductCollectionProduct from './collection/ProductCollectionProduct';
import ProductDetailedStockInfo from './collection/ProductDetailedStockInfo';
import FullProductMatrix from './FullProductMatrix';

const FullProductCollectionItem = types
  .compose(
    ProductCollectionItem,
    types
      .model('FullProductCollectionItem', {
        column_id: types.number,
        row_id: types.number,
        product: ProductCollectionProduct,
        stocks: types.optional(types.map(ProductDetailedStockInfo), {}),
        stockStates: types.optional(types.map(RequestStateType), {}),
      })
      .views((self) => {
        return {
          get collection() {
            return getParentOfType(self, FullProductMatrix);
          },
          get rowName() {
            if (!self.collection) {
              return '';
            }
            const element = self.collection.row.getElementWithId(self.row_id);
            return element ? element.name : '';
          },
          get columnName() {
            if (!self.collection) {
              return '';
            }
            const element = self.collection.column.getElementWithId(
              self.column_id
            );
            return element ? element.name : '';
          },
          get name() {
            return [self.rowName, self.columnName]
              .filter((name) => !!name)
              .join(', ');
          },
        };
      })
  )
  .named('FullProductCollectionItem');

export default FullProductCollectionItem;
